import React, { useEffect, useState } from "react";
import { Copy, Edit, Save, Send, X } from "lucide-react";
import "./LetterView.css";
import useUserStore from "../../store/useUserStore";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

const LetterView = ({ type, letter,consultationId ,updateTransciptSummary}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedLetter, setEditedLetter] = useState(letter);
  const { isMobile } = useUserStore();

      
  useEffect(() => {
    setEditedLetter(letter);
  }, [letter]);

  const handleCopy = () => {
    navigator.clipboard.writeText(letter);
  };
  const handleEdit = () => {
    setIsEditing(true);
    setEditedLetter(letter);
  };

  const handleSave = async () => {
    if(editedLetter===letter){
      handleCancel()
      return
    }
    try {
      await updateTransciptSummary(consultationId, editedLetter, type,true)
      setIsEditing(false)
    } catch (error) {
      console.error("Error saving summary:", error)
    }
    
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditedLetter(letter); // Reset to original transcript
  };

  return (
    <div className="letter-container">
      <div className="letter-header">
        <div className="letter-actions">
          {isEditing ? (
            <>
              <button className="letter-action-button" onClick={handleCancel}>
                <X size={isMobile ? 14 : 18} />
                Cancel
              </button>
              <button
                className="letter-action-button save-button"
                onClick={handleSave}
              >
                <Save size={isMobile ? 14 : 18} />
                Save
              </button>
            </>
          ) : (
            <>
              <button className="letter-action-button" onClick={handleCopy}>
                <Copy size={isMobile ? 14 : 18} />
                Copy
              </button>
              <button className="letter-action-button" onClick={handleEdit}>
                <Edit size={isMobile ? 14 : 18} />
                Edit
              </button>
            </>
          )}
          <button className="letter-action-button" onClick={handleSave}>
            <Send size={isMobile ? 14 : 18} />
            Send
          </button>
        </div>
      </div>

      <div className="letter-content">
        {isEditing ? (
          <textarea
            value={editedLetter}
            onChange={(e) => setEditedLetter(e.target.value)}
            className="letter-editor"
          />
        ) : (
          <Markdown remarkPlugins={[remarkGfm]} className="markdown-content">
            {letter}
          </Markdown>
        )}
      </div>
    </div>
  );
};

export default LetterView;
